import { createTheme } from '@mui/material/styles';

/**
 * Light theme for the admin portal.
 * Uses Onelife brand colors: cyan primary (#2AB6E5) and dark secondary (#1A1A1A).
 */
const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#2AB6E5',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#1A1A1A',
      contrastText: '#FFFFFF',
    },
    background: {
      default: '#F5F5F5',
      paper: '#FFFFFF',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h4: {
      fontWeight: 600,
    },
    h5: {
      fontWeight: 600,
    },
    h6: {
      fontWeight: 600,
    },
  },
  components: {
    MuiAppBar: {
      defaultProps: {
        elevation: 1,
      },
    },
    MuiCard: {
      defaultProps: {
        elevation: 1,
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
  },
});

export default theme;
